// ----- Imports ----- //
import { contributionsOnlyCountries } from '@modules/internationalisation/contributionsOnlyCountries';
// ----- Setup ----- //
const numbersInWords = {
    '1': 'one',
    '2': 'two',
    '5': 'five',
    '6': 'six',
    '7': 'seven',
    '10': 'ten',
    '15': 'fifteen',
    '20': 'twenty',
    '25': 'twenty five',
    '30': 'thirty',
    '35': 'thirty five',
    '40': 'forty',
    '50': 'fifty',
    '75': 'seventy five',
    '100': 'one hundred',
    '125': 'one hundred and twenty five',
    '166': 'one hundred and sixty six',
    '200': 'two hundred',
    '250': 'two hundred and fifty',
    '275': 'two hundred and seventy five',
    '500': 'five hundred',
    '750': 'seven hundred and fifty',
    '800': 'eight hundred',
    '2000': 'two thousand',
    '10000': 'ten thousand',
    '16000': 'sixteen thousand',
};
const defaultConfig = {
    ANNUAL: {
        min: 10,
        minInWords: numbersInWords['10'],
        max: 2000,
        maxInWords: numbersInWords['2000'],
        default: 50,
    },
    MONTHLY: {
        min: 2,
        minInWords: numbersInWords['2'],
        max: 166,
        maxInWords: numbersInWords['166'],
        default: 5,
    },
    ONE_OFF: {
        min: 1,
        minInWords: numbersInWords['1'],
        max: 2000,
        maxInWords: numbersInWords['2000'],
        default: 50,
    },
};
const config = {
    GBPCountries: defaultConfig,
    AUDCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 200,
            maxInWords: numbersInWords['200'],
            default: 20,
        },
        ONE_OFF: {
            min: 1,
            minInWords: numbersInWords['1'],
            max: 16000,
            maxInWords: numbersInWords['16000'],
            default: 50,
        },
    },
    EURCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 166,
            maxInWords: numbersInWords['166'],
            default: 10,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    UnitedStates: {
        ANNUAL: {
            ...defaultConfig.ANNUAL,
            max: 10000,
            maxInWords: numbersInWords['10000'],
        },
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 800,
            maxInWords: numbersInWords['800'],
            default: 15,
        },
        ONE_OFF: {
            ...defaultConfig.ONE_OFF,
            max: 10000,
            maxInWords: numbersInWords['10000'],
        },
    },
    International: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 166,
            maxInWords: numbersInWords['166'],
            default: 10,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    NZDCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 200,
            maxInWords: numbersInWords['200'],
            default: 20,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    Canada: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            minInWords: numbersInWords['2'],
            max: 166,
            maxInWords: numbersInWords['166'],
            default: 10,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
};
const contributionsOnlyCountriesAmountsConfig = {
    defaultContributionType: 'MONTHLY',
    displayContributionType: ['ONE_OFF', 'MONTHLY', 'ANNUAL'],
    amountsCardData: {
        ONE_OFF: {
            amounts: [1, 2, 5, 10],
            defaultAmount: 2,
            hideChooseYourAmount: true,
        },
        MONTHLY: {
            amounts: [2, 3, 5, 7, 9, 12],
            defaultAmount: 5,
            hideChooseYourAmount: true,
        },
        ANNUAL: {
            amounts: [10, 15, 20, 30],
            defaultAmount: 15,
            hideChooseYourAmount: true,
        },
    },
};
const countries = new Set(contributionsOnlyCountries);
const isContributionsOnlyCountry = (countryId) => countries.has(countryId);
// ----- Exports ----- //
export { config, isContributionsOnlyCountry, contributionsOnlyCountriesAmountsConfig, };
